<div class="flex flex-col gap-4">
  <div class="flex flex-col gap-2">
    <label for="change-concrete-select" class="text-sm font-medium">
      {{ 'measurement.change_concrete.field' | translate }}
    </label>
    <p-select
      inputId="change-concrete-select"
      [(ngModel)]="selectedConcreteId"
      [options]="concreteOptions()"
      optionLabel="label"
      optionValue="value"
      styleClass="w-full"
      appendTo="body"
    />
  </div>

  <div class="grid gap-4" style="grid-template-columns: repeat(auto-fit, minmax(200px, 1fr))">
    <div class="flex flex-col gap-0.5">
      <span class="text-sm font-medium text-surface-500 dark:text-surface-400">
        {{ 'measurement.change_concrete.current' | translate }}
      </span>
      <span class="text-base text-surface-900 dark:text-surface-0">{{ currentConcrete()?.name || '-' }}</span>
    </div>
    @if (hasChanged()) {
      <div class="flex flex-col gap-0.5">
        <span class="text-sm font-medium text-surface-500 dark:text-surface-400">
          {{ 'measurement.change_concrete.new' | translate }}
        </span>
        <span class="text-base text-surface-900 dark:text-surface-0">{{ selectedConcrete()?.name || '-' }}</span>
      </div>
    }
  </div>

  @if (hasChanged()) {
    <p-message severity="info" styleClass="w-full">
      {{ 'measurement.change_concrete.confirmNote' | translate: { concreteName: selectedConcrete()?.name } }}
    </p-message>
  }

  <div class="flex flex-wrap gap-2">
    @if (hasChanged()) {
      <p-button
        [label]="'measurement.change_concrete.copySpecifications' | translate"
        severity="secondary"
        [outlined]="true"
        icon="fa-solid fa-copy"
        (onClick)="copySpecificationsFromSelected()"
      />
    }
    @if (specsChanged()) {
      <p-button
        [label]="'measurement.change_concrete.restoreSpecifications' | translate"
        severity="secondary"
        [outlined]="true"
        icon="fa-solid fa-rotate-left"
        (onClick)="restoreOriginalSpecifications()"
      />
    }
  </div>

  <div class="flex flex-col gap-2">
    <label for="change-concrete-specifications" class="text-sm font-medium">
      {{ 'fields.specifications' | translate }}
    </label>
    <p-autocomplete
      inputId="change-concrete-specifications"
      pKeyFilter="num"
      [ngModel]="specifications()"
      (ngModelChange)="onSpecificationsChange($event)"
      multiple
      [typeahead]="false"
      [addOnBlur]="true"
      [addOnTab]="true"
      separator=","
      fluid
    />
  </div>

  @if (measurement.project?.visualizationConfig?.maturity?.app) {
    <div class="flex flex-col gap-2">
      <label for="change-concrete-specifications-maturity" class="text-sm font-medium">
        {{ 'fields.specifications_maturity' | translate }}
      </label>
      <p-autocomplete
        inputId="change-concrete-specifications-maturity"
        pKeyFilter="num"
        [ngModel]="specificationsMaturity()"
        (ngModelChange)="onSpecificationsMaturityChange($event)"
        multiple
        [typeahead]="false"
        [addOnBlur]="true"
        [addOnTab]="true"
        separator=","
        fluid
      />
    </div>
  }

  @if (measurement.project?.visualizationConfig?.relativeMaturity?.app) {
    <div class="flex flex-col gap-2">
      <label for="change-concrete-specifications-maturity-relative" class="text-sm font-medium">
        {{ 'fields.specifications_maturity_relative' | translate }}
      </label>
      <p-autocomplete
        inputId="change-concrete-specifications-maturity-relative"
        pKeyFilter="num"
        [ngModel]="specificationsMaturityRelative()"
        (ngModelChange)="onSpecificationsMaturityRelativeChange($event)"
        multiple
        [typeahead]="false"
        [addOnBlur]="true"
        [addOnTab]="true"
        separator=","
        fluid
      />
    </div>
  }

  <div class="flex justify-end gap-2 mt-2">
    <p-button
      [label]="'button.cancel' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="cancel()"
    />
    <p-button
      [label]="'button.confirm' | translate"
      [disabled]="!hasChanged()"
      (onClick)="confirm()"
    />
  </div>
</div>
